export default __webpack_public_path__ + "static/media/renuma-plus-04.b494fb71.jpg";